import gql from 'graphql-tag';

export default gql`
  mutation UpdateMe($avatar: Media!) {
    UpdateMe(input: { avatar: $avatar }) {
      avatar
    }
  }
`;



// WEBPACK FOOTER //
// ./src/api/query/UpdateAvatar.js